export default __webpack_public_path__ + "static/media/kids.0b93c076.jpg";